<template>
    <div class="step-0">
        <div class="wizard-close" @click="close_popup"><i class="fa fa-close fa-md"></i></div>
        <h2><trans msg="step0_title" /></h2>
        <p><trans msg="step0_description" /></p>
        <label><trans msg="step0_label" /></label>
        <input ref="field" type="text" :class="invalid.indexOf('email') !== -1 && 'error' || null" @click="change_value" :value="email" @keyup="change_value" />
    </div>
</template>

<script>

import Translation from './Translation.vue'

export default {
  name: 'step-0',
  mounted: function() {
    this.$refs.field.focus();
  },
  props: ['email', 'invalid'],
  methods: {
    change_value: function(ev) {
        this.$emit('change_value', ev.target.value);
    },
    close_popup: function(ev) {
        document.getElementsByClassName('wizard-container')[0].style.display = 'none';
    }
  },
  components: {
    'trans': Translation
  }
}
</script>

<style scoped>

    .step-0 {
        position: relative;
    }

    .wizard-close {
        position: absolute;
        right: -15px;
        top: -15px;
        font-size: 24px;
    }
</style>



// WEBPACK FOOTER //
// Step0.vue?73ecfb66